import styled from '@emotion/styled';
import React, { type ReactElement } from 'react';
import { Button, Flex, Text } from 'rebass';

import useNotify from '../../hooks/useNotify';
import colors from '../../theme/colors';
import ErrorDetails from './ErrorDetails';
import { type NotificationType } from './NotifyProvider';

function Notification(): ReactElement | null {
  const { notification, removeNotification } = useNotify();

  if (!notification) {
    return null;
  }

  const { type, message, errorDetails } = notification;

  return (
    <NotificationPopup variant={type} role="alert">
      <Text>{message}</Text>
      {type === `error` ? (
        <>
          <br />
          <ErrorDetails errorDetails={errorDetails} />
          <Button
            type="button"
            ml={5}
            px={2}
            variant="outline"
            onClick={removeNotification}
          >
            Ok
          </Button>
        </>
      ) : null}
    </NotificationPopup>
  );
}

export default Notification;

const NOTIFICATION_CONFIG: Readonly<
  Record<NotificationType, { readonly background: string }>
> = {
  error: { background: '#d9534f' },
  success: { background: '#29ba63' },
  warn: { background: colors.statusOrange },
};

const NotificationPopup = styled(Flex)<{
  variant: NotificationType;
}>`
  position: absolute;
  flex-direction: column;
  max-width: 50vw;
  bottom: 3vh;
  right: 2vw;
  z-index: 11;
  margin-right: 20px;
  padding: 10px 20px;
  border-radius: 25px;
  align-items: center;
  justify-content: center;
  color: white;
  background-color: ${({ variant }) => NOTIFICATION_CONFIG[variant].background};
  animation: fadeIn 1s;
  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`;
